import api from "./axios";

export async function getAllSubscriptions() {
  const res = await api.get("/subscriptions");
  return res.data;
}

export async function getMySubscription() {
  const res = await api.get("/subscriptions/my");
  return res.data;
}

export async function updateSubscription(subscriptionPlanCode, paymentMethodToken) {
  const res = await api.put("/subscriptions", {
    subscriptionPlanCode,
    paymentMethodToken,
  });
  return res.data;
}

/**
 * Schedule a monthly downgrade for the end of the current paid period (free — the renewal
 * machinery applies it at the boundary and bills the new price). Pass null to cancel.
 */
export async function scheduleSubscriptionChange(subscriptionPlanCode) {
  const res = await api.patch("/subscriptions/scheduled-change", { subscriptionPlanCode });
  return res.data;
}

export async function setAutoRenew(enabled) {
  const res = await api.patch("/subscriptions/auto-renew", { enabled });
  return res.data;
}

export async function retryPayment(paymentMethodToken) {
  const res = await api.post("/subscriptions/retry-payment", { paymentMethodToken });
  return res.data;
}

export async function getAddOns() {
  const res = await api.get("/add-ons");
  return res.data;
}

export async function getMyAddOns() {
  const res = await api.get("/add-ons/my");
  return res.data;
}

export async function purchaseAddOn(code, paymentMethodToken) {
  const res = await api.post("/add-ons", {
    code,
    paymentMethodToken,
  });
  return res.data;
}
